import * as React from "react";

/** Kevin (2025-04-11):
 * Hook to add/remove the allow-scroll class from the document element which is necessary
 * for scolling to be enabled on certain pages in the editor.
 */
export const useAllowScroll = () => {
  React.useEffect(() => {
    document.documentElement.classList.add("allow-scroll");
    return () => {
      document.documentElement.classList.remove("allow-scroll");
    };
  }, []);
};
